<template>
  <div class="card border-psychology-primary/20 bg-psychology-primary/5">
    <div class="p-6">
      <div class="text-2xl font-semibold flex items-center gap-3 mb-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-6 h-6 text-psychology-primary">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
        双视角测评说明
      </div>

      <div class="space-y-3">
        <div class="p-3 bg-white/50 rounded-lg">
          <h4 class="font-medium text-gray-900 mb-2">💖 给自己测</h4>
          <p class="text-sm text-gray-600">
            从第一人称视角评估自己的占有欲。题目形式："我经常想知道伴侣在做什么"。
            适合想要自我认知、反思关系模式的用户。
          </p>
        </div>

        <div class="p-3 bg-white/50 rounded-lg">
          <h4 class="font-medium text-gray-900 mb-2">👥 为恋人测</h4>
          <p class="text-sm text-gray-600">
            从观察者视角评估恋人的占有欲。题目形式："Ta经常想知道我在做什么"。
            适合想要理解恋人行为、改善沟通的用户。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DualPerspective'
}
</script>

